import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import { isEmpty } from "lodash";
//redux
import { useSelector, useDispatch } from "react-redux";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { getBookList, getConfiguration, getNavigation, statusNavigation } from "helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";


const NavigationPage = () => {


  const dispatch = useDispatch();
  const { state } = useLocation()
  const router = useNavigate();
  const [isLoading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [parent, setParent] = useState(state?.parent)
  const [typeList, setTypeList] = useState([{ label: 'External Redirect', value: '1' }, { label: 'Template ', value: '2' }, { label: 'Dropdown', value: '3' }, { label: 'Internal Redirect', value: '4' }])


  const getList = (id) => {
    setLoading(true)
    getNavigation(id).then((res) => {
      setList(res)
      setLoading(false)
    }).catch((err) => {
      console.log('err', err)
      setLoading(false)
    })
  }

  useEffect(() => {
    if (state?.parent) {
      getList(state?.parent?.id);
      setParent(state?.parent)
    }
  }, [state]);

  const handleNewClicks = () => {
    router("/navigation-page", { state: {parent : { id: parent?.id , parentName: parent?.eng_name}} })
  };  


  const handleStatus = (status) => {
    statusNavigation(status).then(res => {
      if (res?.success) {
        getList(parent?.id);
        toast.success(res?.message ?? 'Status Updated')
      } else {
        toast.error(res?.message ?? 'somthing went wrong!')
      }
    }).catch(err => {
      console.log('err', err);
    })
  }


  const columns = useMemo(
    () => [
      {
        header: "SNO",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell, row) => {
          return (
            <>
              <h5 className='font-size-14 mb-1'>
                {cell.row.index + 1}
              </h5>
            </>
          )
        }
      },

      {
        header: 'English Name',
        accessorKey: 'eng_name',
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        header: 'Tamil Name',
        accessorKey: 'tamil_name',
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        header: 'Redirect URL',
        accessorKey: 'redirect_url',
        enableColumnFilter: false,
        enableSorting: false,

      },

      {
        header: 'Type',
        accessorKey: 'nav_type',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell, row) => {
          return (
            <>
              <h5 className='font-size-14 mb-1'>
                {typeList.find(e => e.value == cell.row.original?.nav_type).label}
              </h5>
            </>
          )
        }
      },

      {
        header: 'Order',
        accessorKey: 'order',
        enableColumnFilter: false,
        enableSorting: false,

      },

      {
        header: 'Status',
        // accessorKey: 'status',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell) => {
          return (
            <div>
              {
                cell.row.original?.status ?
                <button type="button" onClick={() => handleStatus(cell.row.original?.id)} className="btn btn-success">Active</button>
                :
                <button type="button" onClick={() => handleStatus(cell.row.original?.id)} className="btn btn-danger">Deactive</button>
              }
            </div>
          );
        },
      },
      {
        header: 'Action',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="/navigation-page"
                state={{ parent: {parentId: parent?.id, parentName : parent?.eng_name , ...cellProps.row.original}, isEdit: true }}
                className="text-success"
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              </Link>
              {
                cellProps.row.original?.nav_type == 3 ?
                  <Link
                    to="/"
                    state={{ data: cellProps.getValue() }}
                    className="text-primary"
                  >
                    <i className="mdi mdi-eye font-size-18" id="deletetooltip" />
                  </Link> :
                  ''
              }
            </div>
          );
        }
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Navigation LIST" breadcrumbItem={`${parent?.eng_name}` ?? "Navigation"} />
          <Row>
            {
              isLoading ? <Spinners setLoading={setLoading} />
                :
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <TableContainer
                        columns={columns}
                        data={list || []}
                        isGlobalFilter={true}
                        isPagination={true}
                        SearchPlaceholder="Search..."
                        isCustomPageSize={true}
                        isAddButton={true}
                        handleUserClick={handleNewClicks}
                        buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
                        buttonName="Add Navigation"
                        tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                        theadClass="table-light"
                        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                        pagination="pagination"
                      />
                    </CardBody>
                  </Card>
                </Col>
            }
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(NavigationPage);